<div class="overlay_spinner" *ngIf="isSpinner" style="
Z-INDEX: 1099;">
  <img src="../../assets/img/loaders/loader.svg" alt="loader">
</div>
<div class="my-auto page page-h">
    <div class="main-signin-wrapper2">
       
        <div class="main-card-signin d-md-flex wd-100p">
        <div class="wd-md-50p login d-none d-md-block page-signin-style p-5 text-white" >
            <div class="my-auto authentication-pages">
                <div style="text-align:center; margin-top:4rem">
                    <img id="nitro-image" name="nitro-image" src="../../../assets/img/blue-logo.png" width="130" class=" m-0 mb-3 custm_node" alt="logo">
                    <h3 id="pni-title" name="pni-title">XEDGE</h3>
                </div>
            </div>
        </div>
        <div class="p-5 wd-md-50p d-flex justify-content-center align-items-center">
            <div *ngIf="isLinkValid" class="main-signin-header">

           <button  class="btn btn-primary" (click)="handleLaunchTest()">Launch</button>
          
            </div>
            <div style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
                <div *ngIf="!isLinkValid&&reason?.[0]" >{{reason?.[0]}}</div>
                <div *ngIf="!isLinkValid&&reason?.[1]" style="font-weight: 900;" >{{reason?.[1]}}</div>
                <div *ngIf="!isLinkValid&&reason?.[2]"  >{{reason?.[2]}}</div>
                <div *ngIf="!isLinkValid&&reason?.[3]" style="font-weight: 900;" >{{reason?.[3]}}</div>
            </div>
     

        </div>
    </div>
    </div>
    <div class="py-0 text-center"><p id="copy-right" name="copy-right" style="margin-bottom: 0px;">© 2024 XEDGE.</p></div>
    <div class="mt-0 text-center"><span id="version" name="version" style="font-size: 15px;">Version {{versionNo}}</span></div>
</div>
